import { skipToken, useQuery } from "@tanstack/react-query";

import useGetAccessToken from "components/Login/useGetAccessToken";
import { getScopeFiles } from "../methods/getScopeFiles";
import { SCOPE_FILES_QUERY_KEY } from "./scopeFilesKeys";

interface UseScopeFilesQueryOptions {
  /** Undefined on the new-chat route, where there is no thread to list. */
  threadId: string | undefined;
}

/**
 * Lists every file the File API stores for a chat thread (ADR 071).
 * `usePutMessagesMutation` invalidates this key, so the list refreshes after
 * each messages PUT.
 */
export default function useScopeFilesQuery({
  threadId,
}: UseScopeFilesQueryOptions) {
  const getAccessToken = useGetAccessToken();

  return useQuery({
    queryKey: SCOPE_FILES_QUERY_KEY(threadId ?? ""),
    queryFn:
      threadId === undefined
        ? skipToken
        : () => getScopeFiles(threadId, getAccessToken),
    refetchOnWindowFocus: false,
    retry: false,
  });
}
